import React from 'react';
import Footer from '../components/footer';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Why from '../components/why';
import Hero from '../components/hero';
function WhyPage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <Hero />
        <Why />
        <Footer />
      </div>
    );
  }

 export default WhyPage; 
  
  